
import ModuleBase, { moduleInit, ViewLayer, implementFunction, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import ModuleManager from "../../../../framework/core/module_manager";
import Utility from "../../../../utility/utility";
import TimeManager from "../../../../manager/time_manager";
import * as ProtoPokerRoom from "../../net/proto/proto_poker_room";
import NetMsgDataBase from "../../net/net_msg_data_table_base";
import ModelBase from "../../../../framework/core/mvvm/model_base";
import ChatInfoView from "./chatinfo_view";
import GameServer from "../../../hall/server/gameserver/game_server";
import ModelData, { IUserData } from "../../../public/model_data";
import OhterChatInfoView from "./ohter_chatinfo_view";
import BlackJackTableView from "../../../blackjack/module/table/blackjack_table_view";
import EventManager from "../../../../manager/event_manager";
import BlackJackTableModule from "../../../blackjack/module/table/blackjack_table_module";
import Module from "../../../../framework/core/mvvm/module_base";
import { friend_utils } from "../../../hall/module/friend/friend_utils";
import PlayerIconModule from "../../../hall/module/playericon/playerIcon";
import Shop from "../../../hall/module/shop/shop";
const { ccclass } = cc._decorator;
enum ChatMsgType {
    voiceMsg = 0,
    shotMsg = 1,
    emojiMsg = 2,
    text = 3,
    iconMsg=4,
    gift = 10,
    tmpLeave = 99,
}

@ccclass
@moduleInit("OtherChatInfoEx")
export default class OtherChatInfoEx extends Module<OhterChatInfoView,null> {

    _model: ModelBase = new ModelBase()
    _lastPinTime: number = 0
    protected LastSendChatTime: number = 0

    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = 'package/table/chat_emoji/module/public_other_chat_Info';
        this.viewType = OhterChatInfoView;
        this.needAnim = true
        this.needViewMask = true
        this.clickAnywhereClose = true;
        this.needDeferShow = true;
        
    }

     posX=0
     posY=0
     emojiId=0
     clickPlayerId=0
     moduleName:string=""

     isCanClick:boolean = true;//表情点击

    protected isVipPlayer:boolean = false;

    onInit() {
        this._model.init(GameServer.instance.netClient)
        this.addEvent();
    }
 
    onShow(arg0) {
        this.clickPlayerId=arg0["playerId"]
        this.moduleName=arg0["moduleName"]
        cc.log("Open_PlayerId"+this.clickPlayerId)
        this.view.refreshPlayerInfo(this.clickPlayerId);
    }


    
    addEvent() {
          // this.eventBind("seatViewClick", this.sendChat)
          this.view.btnClose.node.on('click', this.onClick_btnClose, this);
          this.eventUnBind('seatViewClick',this.sendChat)
          this.eventBind("seatViewClick", this.sendChat)
          let childs = this.view.emojiBtnList;
          for(let i=0;i<childs.length;i++)
          {
              childs[i].node.on('click', this.onClick_Emoji, this);   
          }
    }

    onDeferShow(arg0){
        this.clickPlayerId=arg0["playerId"]
        this.moduleName=arg0["moduleName"]
        this.updateFriendState(()=>{
            this.show();
        })
    }

    @bindButtonClickEvent('addFriendBtn')
    addFriend(){
        friend_utils.addFriend(this.clickPlayerId,this,(result)=>{
            if (result) {
                this.updateFriendState();
            }
        })
    }

    @bindButtonClickEvent('deleteBtn')
    deleteFriend(){
        friend_utils.removeFriend(this.clickPlayerId,this,(result)=>{
            this.view.refreshFriendBtn(result ? 1:0)
        })
    }

    updateFriendState(cb?:Function){
        friend_utils.isFriend(this.clickPlayerId,this,(result)=>{
            this.view.refreshFriendBtn(result ? 0:1)
            cb && cb();
        });
    }

    private onClick_btnClose() {
        // Utility.playButtonSound()
        this.hide()
    }


    protected scorllBegin(){
        this.isCanClick = false;
    }

    protected scrollEnd(){
        this.isCanClick = true;
    }

    protected onClick_Emoji(event: cc.Button): boolean {
        
        if (!this.isCanClick) {
            return
        }
        
        let isClickValid = Utility.btnClickValid(100)
        if (!isClickValid) {
            return isClickValid
        }
        
        // let bjView:BlackJackTableModule = ModuleManager.instance.getModule("BlackJackTableModule")
        // let emojiMap=bjView.setShowState
        // EventManager.instance.dispatch("get_seatView_Info",emojiMap)
        let node: cc.Node = event.node
        let nodeName  = node.name.split("_")
        let na=nodeName[1]
        let str:string=na+"_"
        str+=ModelData.instance.roleData.id+"_"
        str+=this.clickPlayerId.toString()

        if (!this.isVipPlayer && Number(na) >= 20) {
            ModuleManager.instance.showModule<Shop>(Shop, {tag: "tag_vip"})
            return;
        }

        Utility.playButtonSound()
        
        let curModule:Module<null,null>=ModuleManager.instance.getModule(this.moduleName)
        let clickNode:cc.Node=curModule.getSeatNodeById(this.clickPlayerId)
        if(!clickNode)
        {
            return;
        }
        
        this.sendChat(str)

        ModuleManager.instance.hideModule("OtherChatInfoEx")
        
    }
    sendChat(content) {
        let AppRunningTime = TimeManager.instance.AppRunningTime
        if (this.LastSendChatTime > 0 && this.LastSendChatTime + 2.6 > AppRunningTime) {
            return
        }
   
        this.LastSendChatTime = AppRunningTime
        let chatMsgType = ChatMsgType.iconMsg
        this.send_chat_request(chatMsgType, content)
    }
    send_chat_request(chatMsgType: number, text: string){

        let base=ModuleManager.instance.getModule("")
        let chatmsg: ProtoPokerRoom.Room.IChatMsg = {
            msgType: chatMsgType,
            text: text
        }
        let protoData: ProtoPokerRoom.Room.IChatMsgReq = {
            chatMsg: chatmsg
        }
        this._model.sendMsg(NetMsgDataBase.Chat, protoData)

        //EventManager.instance.dispatch("show_emoji_msg",this.moduleName,protoData,false)
    }
}